<template>
  <div id="collection">
    <!-- Content Header -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0 text-dark">合集詳情</h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item active">相簿</li>
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'AdminCollection' }">
                  合集列表
                </router-link>
              </li>
              <li class="breadcrumb-item active">合集詳情</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content Header -->

    <!-- Main content -->
    <div class="content">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-md-8 col-sm-12">
            <div class="card card-primary">
              <div class="card-body">
                <div class="row">
                  <div class="col-4">
                    <label for="b-collection-image"
                      >合集封面圖（建議尺寸：450x450）</label
                    >
                    <!-- Collection Image -->
                    <div class="b-album-thumbnail w-100">
                      <div class="b-album-responsive mb-2">
                        <div class="b-album-sizer"></div>
                        <div class="b-album-content">
                          <div class="b-layout h-100 align-center ma-0">
                            <div
                              v-if="fengmianId == 0 || fengmianUrl == ''"
                              class="b-layout-flex"
                            >
                              <div class="text-center o-60">
                                <i class="fas fa-image fa-2x"></i>
                              </div>
                            </div>
                            <div class="fengmianDiv" v-else>
                              <img class="fengmian" :src="fengmianUrl" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="aaa">
                      <el-upload
                        class="upload-demo"
                        ref="fengmianUpload"
                        :action="uploadImageUrl"
                        :show-file-list="false"
                        :on-success="handleSuccess"
                        :on-error="errorUpload"
                        :before-upload="uploadImgCheck"
                      >
                        <button
                          type="button"
                          class="btn btn-block btn-default btn-sm mb-3"
                        >
                          <i class="nav-icon fas fa-image mr-1"></i>
                          上載自訂縮圖
                        </button>
                      </el-upload>
                    </div>
                    <!-- /.Collection Image -->
                  </div>
                  <div class="col-8">
                    <el-form
                      :model="ruleForm"
                      :rules="rules"
                      ref="ruleForm"
                      label-width="100px"
                      class="demo-ruleForm"
                      label-position="top"
                      :disabled="formDisabled"
                    >
                      <el-form-item label="合集名稱" prop="name">
                        <el-input v-model="ruleForm.name"></el-input>
                      </el-form-item>
                      <el-form-item label="合集簡介" prop="jianjie">
                        <el-input
                          type="textarea"
                          placeholder="请输入内容"
                          v-model="ruleForm.jianjie"
                          show-word-limit
                        >
                        </el-input>
                      </el-form-item>
                      <el-form-item label="合集相簿" prop="heji">
                        <el-select
                          v-model="ruleForm.heji"
                          multiple
                          filterable
                          placeholder="请选择"
                          remote
                          :remote-method="remoteMethod"
                        >
                          <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item
                        label="關鍵字（以 ',' 作分隔，不需加上空格）"
                        prop="key"
                      >
                        <el-input v-model="ruleForm.key"></el-input>
                      </el-form-item>
                      <el-form-item label="公開狀態" prop="pubStat">
                        <el-select
                          v-model="ruleForm.pubStat"
                          placeholder="请选择"
                        >
                          <el-option
                            v-for="item in statOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-form>
                  </div>
                </div>
              </div>
              <!-- /.card-body -->
            </div>
            <!-- /.card -->
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
        <div class="row justify-content-center">
          <div class="col-8">
            <input
              type="button"
              value="取消"
              class="btn btn-secondary float-left"
              @click="cancel"
            />
            <!-- <a href="#" class="btn btn-secondary">取消</a> -->
            <input
              type="button"
              value="保存"
              class="btn btn-primary float-right"
              @click="save"
            />
          </div>
        </div>
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content -->
  </div>
</template>
<script>
import { Message } from "element-ui";
import base from "../../api/httpApi/base";
export default {
  components: {},
  data() {
    return {
      formDisabled: false,
      sgL_PG_CName: "",
      ruleForm: {
        name: "",
        jianjie: "",
        heji: null,
        key: "",
        pubStat: true,
      },
      rules: {
        name: [{ required: true, message: "請輸入合集名稱", trigger: "blur" }],
        heji: [{ required: true, message: "請選擇合集相簿", trigger: "blur" }],
      },
      statOptions: [
        {
          value: true,
          label: "顯示",
        },
        {
          value: false,
          label: "隱藏",
        },
      ],
      options: [],
      uploadImageUrl: "",
      fengmianId: 0,
      fengmianUrl: "",
    };
  },
  created() {
    this.uploadImageUrl = `${base.dev}/TokenAuth/UploadImg/Upload/FormImg?Type=PhotoCollection&id=${this.loginUser.userId}`;
    this.getOption();
    if (this.$route.query && this.$route.query.id) {
      this.formDisabled = true;
      this.getInfo(this.$route.query.id);
    }
  },
  methods: {
    getInfo(id) {
      let params = {
        Id: id,
      };
      this.$api.albumApi
        .AdminPhotoCollectionGet(params)
        .then((res) => {
          if (res.data.success) {
            this.ruleForm.name = res.data.result.sgL_PhotoName;
            this.ruleForm.jianjie = res.data.result.sgL_Content;
            this.ruleForm.key = res.data.result.sgL_Keyword;
            this.ruleForm.pubStat = res.data.result.sgL_IsShow;
            this.fengmianId = res.data.result.sgL_ImageId;
            this.fengmianUrl = res.data.result.sgL_ImageUrl;
            if (res.data.result.photoCollectionJoinDto) {
              res.data.result.photoCollectionJoinDto.forEach(
                (item, ix, arr) => {
                  let isExist = false;
                  for (let item2 in this.options) {
                    if (item.sgL_PG_Coid == this.options[item2].value) {
                      isExist = true;
                    }
                  }
                  if (!isExist) {
                    this.options.push({
                      value: item.sgL_PG_Coid,
                      label: item.sgL_Name,
                    });
                  }
                  this.ruleForm.heji.push(item.sgL_PG_Coid);
                }
              );
            }
          } else {
            this.$message.error(res.data.error.message);
          }
        })
        .catch((data) => {
          this.formDisabled = false;
        })
        .then(() => {
          this.formDisabled = false;
        });
    },
    remoteMethod(query) {
      this.sgL_PG_CName = query;
      this.getOption();
    },
    getOption() {
      let params = {
        SkipCount: 0,
        MaxResultCount: 100,
        sgL_PG_CName: this.sgL_PG_CName,
      };
      this.$api.albumApi.GetAdminPhotoGalleryList(params).then((res) => {
        if (res.data.success) {
          this.options = [];
          res.data.result.items.forEach((item, ix, arr) => {
            this.options.push({
              value: item.id,
              label: item.sgL_PG_CName,
            });
          });
          /* if (this.$route.query && this.$route.query.id) {
            this.getInfo(this.$route.query.id);
          } */
        } else {
          this.$message.error(res.data.error.message);
        }
      });
    },
    optionsAdd(arr, obj) {},
    cancel() {
      this.$router.push({
        name: "AdminCollection",
      });
    },
    save() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          //判断封面是否上传
          if (this.fengmianId == 0) {
            this.$message.error("請上傳封面");
            return;
          }
          let params = {
            sgL_ImageId: this.fengmianId,
            sgL_PhotoName: this.ruleForm.name,
            sgL_Content: this.ruleForm.jianjie,
            sgL_Coids: this.ruleForm.heji,
            sgL_Keyword: this.ruleForm.key,
            sgL_IsShow: this.ruleForm.pubStat,
          };
          let mmm = null;
          if (this.$route.query && this.$route.query.id) {
            params.id = this.$route.query.id;
            mmm = this.$api.albumApi.AdminPhotoCollectionUpdate(params);
          } else {
            mmm = this.$api.albumApi.AdminPhotoCollectionCreate(params);
          }
          mmm.then((rst) => {
            if (rst.data.success) {
              this.$router.push({
                name: "AdminCollection",
              });
            } else {
              this.$message.error(rst.data.error.message);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleSuccess(res, file) {
      this.$refs.fengmianUpload.clearFiles();
      if (res.success) {
        this.fengmianId = res.result.uploadId;
        this.fengmianUrl = res.result.url;
      } else {
        this.$message.error("上傳失敗:" + res.error.message);
      }
    },
    errorUpload(err, file, fileList) {
      this.$message.error("上傳失敗" + err);
    },
  },
};
</script>
<style scoped>
.fengmianDiv {
  width: 100%;
  height: 100%;
}
.fengmian {
  width: 100%;
  height: 100%;
}
.aaa >>> .el-upload {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/AdminAlbum/CollectionEdit.vue